import log from 'loglevel'
import { IconClusterLayer } from '@/js/custom-layers/IconClusterLayer.js'

// レイヤーID
const LAYER_ID = 'iFieldDomain'

/**
 * iFieldの機能ドメインのレンダラー
 */
export default class DomainRenderer {
  /**
   * コンストラクタ
   */
  constructor({ layerId } = {}) {
    this.layerId = layerId || LAYER_ID
  }

  /**
   * レンダラー関数を作成する
   * @param {Array.<Object>} data データ
   * @param {Object} props 上書きするprops
   * @returns {Object} レンダラー {id: String, render: Function.<IconClusterLayer>}
   */
  createRenderer(data, props) {
    log.debug(`[DEBUG] start render ${this.layerId}`, data, props)

    return {
      id: this.layerId,
      render: () =>
        new IconClusterLayer({
          id: this.layerId,
          data,
          pickable: true,
          billboard: true,
          sizeScale: 1,
          radius: 88,
          getPosition: (d) => d.geom.geometry.coordinates,
          getIcon: (d) => (d.properties.cluster ? 'cluster' : 'default'),
          getIconSize: (d) => (d.properties.cluster ? 80 : 64),
          fontWeight: 'bold',
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "游ゴシック Medium", "Yu Gothic", YuGothic, YuGothicMedium, "Hiragino Kaku Gothic ProN", Meiryo, sans-serif',
          fontSettings: {
            sdf: true,
          },
          getText: (d) =>
            d.properties.cluster ? `${d.properties.point_count}` : '',
          getTextSize: 16,
          getTextColor: [255, 255, 255],
          getTextPixelOffset: [16, 1],
          parameters: {
            depthTest: false,
            blend: true,
          },
          ...props,
        }),
    }
  }
}
